import { useSetState } from '@domain-group/react-hooks'

import useProviderPriceListItems from '@hooks/useProviderPriceListItems'
import useServiceProduct from '@hooks/useServiceProduct'

import type { ProviderPriceListModel } from '@models/types'

type UsePriceListProductOptions = {
  isMaster: boolean,
  providerPriceList: ProviderPriceListModel,
  serviceProductId: number,
}

const defaultState = {
  isOpen: false,
}

function usePriceListProduct(options: UsePriceListProductOptions) {
  const { providerPriceList, serviceProductId } = options

  const [state, setState] = useSetState(defaultState)
  const { isOpen } = state

  const serviceProductPayload = useServiceProduct({ id: serviceProductId })
  const { serviceProduct } = serviceProductPayload

  const providerPriceListItemsPayload = useProviderPriceListItems({
    filters: {
      provider_price_list_id: providerPriceList.id,
      // @ts-expect-error TS2339
      service_product_id: serviceProduct?.id,
    },
    performHttpRequests: false,
  })

  const { filteredProviderPriceListItems, visiblePriceListItems } = providerPriceListItemsPayload

  // @ts-expect-error
  const isLocked = serviceProduct?.options?.locked || false

  return {
    callbacks: {
      toggleOpen: () => setState({ isOpen: !isOpen }),
    },
    filteredProviderPriceListItems,
    isLocked,
    isOpen,
    serviceProduct,
    visiblePriceListItems,
  }
}

export default usePriceListProduct
